import {cashToChinese, initDefValuesByFun} from "@/main-page/utils/initValues";
import dayjs from "dayjs";
import GoingUtils from "@/utils/goingUtils";
import {GoingNewUtils} from 'xmgoing-utils';
import {CurrentUtils} from "xmgoing-server";
import {getUserById} from "@/api/login";
import {queryDomainDetailByCode} from "@/main-page/servers/formPageServer";
import {noMoneyFormat} from "@/main-page-form/ctls/baseCtls/xmPrice/hooks/usePriceCtl";

/**
 * 下拉过滤
 * @param input
 * @param option
 */
export const filterOption = (input: string, option: any, valueFlag = true) => {
  const inputValue = (input + '').toLowerCase();

  const optionValue = (option.value + '').toLowerCase();
  const optionTitle = option.title ? (option.title + '').toLowerCase() : '';
  const optionLabel = option.label ? (option.label + '').toLowerCase() : '';

  if (valueFlag) {
    return optionValue.indexOf(inputValue) >= 0 ||
      optionTitle.indexOf(inputValue) >= 0 ||
      optionLabel.indexOf(inputValue) >= 0;
  } else {
    return optionTitle.indexOf(inputValue) >= 0 ||
      optionLabel.indexOf(inputValue) >= 0;
  }
};


/**
 * 获取关联字段
 * @param args
 * @param fieldList
 */
export function getFieldKeys(args, fieldList) {
  if (Array.isArray(args) && args.length > 0) {
    args.forEach((argItem) => {
      if (argItem.type === 'field') {
        const fieldItem = unref(fieldList).filter((propName) => {
          return propName === argItem.value;
        })[0];
        if (!fieldItem) {
          fieldList.push(argItem.value);
        }
      }
      if (argItem.type === 'fun') {
        if (argItem.args && argItem.args.length > 0) {
          getFieldKeys(argItem.args, fieldList)
        }
      }
    });
  }
}


/**
 * 同步数据源
 * @param tableId
 */
export const tongbuDomain = function (config, tableCode, selKey, createChildren) {
  queryDomainDetailByCode({
    tableCode, backFun: (res) => {
      if (unref(config).children && unref(config).children.length > 0) {
        GoingUtils.executeConfirm({
          content: '已经存在子节点，您确认重新生成!', backFun: () => {
            createChildren(res, selKey);
          }
        })
      } else {
        createChildren(res, selKey);
      }
    }
  });
}

/**
 * 获取所以关联字段信息
 * @param propDef
 */
export function getAllFieldKeys(propDef) {
  let allFieldKeys: any = [];
  unref(propDef).forEach((configItem) => {
    const {args} = configItem;
    const fieldList: any = [];
    getFieldKeys(args, fieldList);
    allFieldKeys = [...allFieldKeys, ...fieldList];
  })
  return allFieldKeys;
}

//获取日期数据
function getDateAry({props,modelObj,model,args,componentKey}, userFormat = "") {
  const valueList: any = [];
  if (Array.isArray(args)) {
    args.forEach((argItem) => {
      let backValue = "";
      if (argItem.type === 'fun') {
        //函数表达式
        backValue = initDefValuesByFun({propDef: [argItem], props, modelObj,componentKey, model}, false)
      } else if (argItem.type === 'useDef') {
        //用户定义
        backValue = argItem.value;
      } else {
        if (Array.isArray(unref(modelObj)[argItem.value])) {
          unref(modelObj)[argItem.value].forEach((aryItem) => {
            valueList.push(aryItem);
          })
        } else {
          if (unref(modelObj)[argItem.value]) {
            //表单值
            backValue = unref(modelObj)[argItem.value].split(";")
          }
        }
      }

      if (backValue && backValue.length > 0) {
        if (backValue && Array.isArray(backValue)) {
          backValue.forEach((itemDb) => {
            const date: any = dayjs(itemDb, "YYYY-MM-DD");
            if ((date.$d + "") !== 'Invalid Date') {
              valueList.push(date);
            }
            return
          })
        }
        //如果是字符串 则转换成日期
        if (typeof (backValue) === 'string') {
          const date: any = dayjs(backValue, userFormat || unref(props).format || "YYYY-MM-DD");
          if ((date.$d + "") !== 'Invalid Date') {
            valueList.push(date);
          }
          return
        }
        if (Object.prototype.toString.call(backValue) === '[object Date]') {
          valueList.push(backValue);
          return;
        }
      }
    });
  }
  return valueList
}

function getPitemListTotal({argItem, modelObj}) {
  let backNum = 0;
  const keyAry = argItem.value.split(".");
  if (keyAry[0]) {
    let pItemList = unref(modelObj)[keyAry[0]];
    if (typeof pItemList === 'string' && pItemList.length > 0) {
      try {
        pItemList = JSON.parse(pItemList);
      } catch (e) {
        pItemList = [];
      }
    }
    //动态子表格记录集合
    if (pItemList && Array.isArray(pItemList)) {
      //循环记录集合 进行数据合并
      pItemList.forEach((recordDb) => {
        if (recordDb[keyAry[1]] && !isNaN(recordDb[keyAry[1]])) {
          backNum = parseFloat(noMoneyFormat(backNum)) + parseFloat(noMoneyFormat(recordDb[keyAry[1]]));
        } else {
          backNum = parseFloat(noMoneyFormat(backNum)) + parseFloat(0);
        }
      })
    }
  }
  return backNum;
}

/**
 * 获取数组集合
 * @param args
 * @param modelObj
 */
function getNumberAry({props,modelObj,model,args,componentKey}) {
  const valueList: any = [];
  if (Array.isArray(args)) {
    args.forEach((argItem) => {
      if (argItem.type === 'fun') {
        //函数表达式
        valueList.push(initDefValuesByFun({propDef: [argItem], props, modelObj, model,componentKey}, false));
      } else if (argItem.type === 'useDef') {
        //用户定义
        if (argItem.value && !isNaN(parseFloat(noMoneyFormat(argItem.value)))) {
          valueList.push(parseFloat(noMoneyFormat(argItem.value)));
        }
      } else {
        if (argItem.value.indexOf(".") > 0) {
          if (unref(props).noListTotal === false) {
            const keyAry = argItem.value.split(".");
            if (modelObj[keyAry[1]] && isNaN(parseFloat(noMoneyFormat(modelObj[keyAry[1]])))) {
              valueList.push(0);
            } else {
              valueList.push(parseFloat(noMoneyFormat(modelObj[keyAry[1]])));
            }
          } else {
            valueList.push(parseFloat(getPitemListTotal({argItem, modelObj})));
          }
        } else {
          //表单值
          if (unref(modelObj)[argItem.value] && !isNaN(parseFloat(noMoneyFormat(unref(modelObj)[argItem.value])))) {
            valueList.push(parseFloat(noMoneyFormat(unref(modelObj)[argItem.value])));
          }
        }
      }

    });
  }
  return valueList
}

/**
 * 获取文本对数组集合
 * @param args
 * @param modelObj
 */
function getTextAry({props,modelObj,model,args,componentKey}) {
  const valueList: any = [];
  if (Array.isArray(args)) {
    args.forEach((argItem) => {
      if (argItem.type === 'fun') {
        //函数表达式
        valueList.push(initDefValuesByFun({propDef: [argItem], props, componentKey,modelObj, model}, false));
      } else if (argItem.type === 'useDef') {
        //用户定义
        valueList.push(argItem.value);
      } else {
        //表单值
        valueList.push(unref(modelObj)[argItem.value] || '');
      }
    });
  }
  return valueList
}


/**
 * 获取布尔对数组集合
 * @param args
 * @param modelObj
 */
function getBooleanAry({props,modelObj,model,args,componentKey}) {
  const valueList: any = [];
  if (Array.isArray(args)) {
    args.forEach((argItem) => {
      if (argItem.type === 'fun') {
        //函数表达式
        valueList.push(GoingNewUtils.parseBoolean(initDefValuesByFun({
          propDef: [argItem],
          componentKey,
          props,
          modelObj,
          model
        }, false)));
      } else if (argItem.type === 'useDef') {
        //用户定义
        valueList.push(GoingNewUtils.parseBoolean(argItem.value));
      } else {
        //表单值
        valueList.push(GoingNewUtils.parseBoolean(unref(modelObj)[argItem.value]));
      }
    });
  }
  return valueList
}

/**
 * SUM函数可以获取一组数值的总和
 * @param props
 * @param modelObj
 * @param args
 */
export function sumFunDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    //计算总和
    backValue = valueList.reduce((prev, cur) => {
      return prev + cur
    }, 0);
  }
  return backValue;
}

/**
 * 获取时间戳
 * @param props
 * @param modelObj
 * @param args
 */
export function timestampFunDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = dayjs(valueList[0]).unix()
    }
  }
  return backValue;
}

/**
 * 函数可以比较两个文本是否完全相同，完全相同则返回true，否则返回false
 * @param props
 * @param modelObj
 * @param args
 */
export function exactFunDeal({props,modelObj,model,args,componentKey}) {
  let backValue = false;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      if (valueList[0] === valueList[1]) {
        backValue = true;
      } else {
        backValue = false;
      }
    }
  }
  return backValue;
}

/**
 * 函数可以从一个文本的第一个字符开始返回指定个数的字符
 * @param props
 * @param modelObj
 * @param args
 */
export function exactLeftDeal({props,modelObj,model,args,componentKey}) {
  let backValue = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      backValue = (valueList[0] + "").substring(0, valueList[1])
    }
  }
  return backValue;
}

/**
 * 函数可以获取文本中的字符个数
 * @param props
 * @param modelObj
 * @param args
 */
export function exactLenDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = (valueList[0] + "").length;
    }
  }
  return backValue;
}

/**
 * 函数可以将一个文本中的所有大写字母转换为小写字母
 * @param props
 * @param modelObj
 * @param args
 */
export function exactLowerDeal({props,modelObj,model,args,componentKey}) {
  let backValue = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = (valueList[0] + "").toLowerCase();
    }
  }
  return backValue;
}

/**
 * 返回文本中从指定位置开始的指定数目的字符  (文本,开始位置_数字,指定数目)
 * @param props
 * @param modelObj
 * @param args
 */
export function exactMidDeal({props,modelObj,model,args,componentKey}) {
  let backValue = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 3) {
      backValue = (valueList[0] + "").substring(valueList[1], valueList[2]);
    }
  }
  return backValue;
}

//使用正则匹配字符串，截取首字符，转为大写后与其他字符拼接起来。
function upperFirstConcat(strVal) {
  let str = (strVal + "").toLowerCase()
  str = str.replace(/\b\w+\b/g, word => {
    return word.substring(0, 1).toUpperCase + word.substring(1)
  })
  return str
}

/**
 * 函数可以将字符串中的每个字的首字母以大写形式拼接返回
 * @param props
 * @param modelObj
 * @param args
 */
export function exactPinyInHeadCharDeal({props,modelObj,model,args,componentKey}) {
  let backValue = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = upperFirstConcat(valueList[0]);
    }
  }
  return backValue;
}

/**
 * 函数可以根据指定的字符数，将部分文本替换为不同的文本
 * @param props
 * @param modelObj
 * @param args
 */
export function exactReplaceDeal({props,modelObj,model,args,componentKey}) {
  let backValue = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 4) {
      //获取需要替换的字符串
      const oldStr = (valueList[0] + "").substring(valueList[1], valueList[1] + valueList[2]);
      //替换成新字符串 返回
      backValue = (valueList[0] + "").replace(oldStr, valueList[3]);
    }
  }
  return backValue;
}

function right(mainStr, lngLen) {
  if (mainStr.length - lngLen >= 0 && mainStr.length >= 0 && mainStr.length - lngLen <= mainStr.length) {
    return mainStr.substring(mainStr.length - lngLen, mainStr.length);
  } else {
    return null;
  }
}

/**
 * 函数可以将文本重复一定次数
 * @param props
 * @param modelObj
 * @param args
 */
export function exactReptDeal({props,modelObj,model,args,componentKey}) {
  let backValue = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      const repStr: any = []
      for (let num = 0; num < valueList[1]; num++) {
        repStr.push(valueList[0]);
      }
      backValue = repStr.join("");
    }
  }
  return backValue;
}

/**
 * 函数可以获取由给定文本右端指定数量的字符构成的文本值
 * @param props
 * @param modelObj
 * @param args
 */
export function exactRightDeal({props,modelObj,model,args,componentKey}) {
  let backValue = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      backValue = right(valueList[0], valueList[1]);
    }
  }
  return backValue;
}

/**
 * 函数可以将文本按指定分割符分割成数组，需配合ARRAYGET来获取指定位置字符，如ARRAYGET(SPLIT(text, text_separator), 1)
 * @param props
 * @param modelObj
 * @param args
 */
export function exactSplitDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = [];
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      backValue = (valueList[0] + "").split(valueList[1]);
    }
  }
  return backValue;
}

/**
 * 函数可以将数字转化成文本
 * @param props
 * @param modelObj
 * @param args
 */
export function exactTextDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = (valueList[0] + "");
    }
  }
  return backValue;
}

/**
 * 函数可以将文本转化为数字
 * @param props
 * @param modelObj
 * @param args
 */
export function exactValueDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = null;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = parseFloat((valueList[0] + ""));
    }
  }
  return backValue;
}

/**
 * 如果所有参数都为真，函数返回布尔值true，否则返回布尔值 false
 * @param props
 * @param modelObj
 * @param args
 */
export function exactAndDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = true;
  if (Array.isArray(args)) {
    const valueList: any = getBooleanAry({props,modelObj,model,args,componentKey});
    valueList.forEach((itemDb) => {
      if (itemDb !== true) {
        backValue = false;
      }
    })
  }
  return backValue;
}

/**
 *
 * @param props
 * @param modelObj
 * @param args
 */
export function exactOrDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  if (Array.isArray(args)) {
    const valueList: any = getBooleanAry({props,modelObj,model,args,componentKey});
    valueList.forEach((itemDb) => {
      if (itemDb === true) {
        backValue = true;
      }
    })
  }
  return backValue;
}

/**
 * 函数比较两个日期组件的大小。
 * @param props
 * @param modelObj
 * @param args
 */
export function exactTimeCompareDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList[0] && valueList[1]) {
      if (dayjs(valueList[0]).unix() > dayjs(valueList[1]).unix()) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}

/**
 * 函数可以返回所有参数的异或值
 * @param props
 * @param modelObj
 * @param args
 */
export function exactXorDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList[0] && valueList[1]) {
      if (dayjs(valueList[0]).unix() > dayjs(valueList[1]).unix()) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}

//返回一个数的绝对值:
export function exactAbsDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      return Math.abs(valueList[0]);
    } else {
      return null;
    }
  }
}

/**
 * 值相减操作
 * @param props
 * @param modelObj
 * @param args
 */
export function exactSUBDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = 0;
  const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
  if (valueList && valueList.length > 0) {
    //计算总和
    backValue = valueList[0] - valueList[1];
  }
  return backValue;
}

//函数用于返回组件值相加总和。
export function exactADDDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = 0;
  const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
  if (valueList && valueList.length > 0) {
    //计算总和
    backValue = valueList.reduce((prev, cur) => {
      return prev + cur
    }, 0);
  }
  return backValue;
}

export function exactCeilingDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

export function exactFixedDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      return Math.abs(valueList[0]);
    } else {
      return null;
    }
  }
}

export function exactFloorDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

export function exactIntDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      return parseInt(valueList[0]);
    } else {
      return null;
    }
  }
}

export function exactLargeDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

export function exactLogDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

//获取最大值
export function exactMaxDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length > 0) {
      let maxNum = valueList.reduce(function (prev, curr) {
        return prev > curr ? prev : curr;
      });
      return maxNum;
    } else {
      return null;
    }
  }
}

//获取最小值
export function exactMinDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length > 0) {
      let minNum = valueList.reduce(function (prev, curr) {
        return prev > curr ? curr : prev;
      });
      return minNum;
    } else {
      return null;
    }
  }
}

export function exactModDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

export function exactPowerDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

/**
 * 除法计算
 * @param props
 * @param modelObj
 * @param args
 */
export function exactDivisionDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList[0] > 0 && valueList[1] > 0) {
      //计算除法
      backValue = valueList[0] / valueList[1];
    }
  }
  return backValue;
}

/**
 * 乘法计算
 * @param props
 * @param modelObj
 * @param args
 */
export function exactProductDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 1;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    //计算总和
    valueList.forEach((val) => {
      backValue = backValue * val;
    })
  }
  return backValue;
}

export function exactRoundDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

export function exactSqrtDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

export function exactSumproductDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = false;
  return backValue;
}

//函数用于获取当前登录人昵称
export function exactGETUSERNAMEDeal({props,modelObj,model,args,componentKey}) {
  CurrentUtils._loadUser(false, (userJson) => {
    unref(modelObj)[unref(model).key] = userJson["name"];
  })
}

//函数用于获取当前登录人工号
export function exactLOGINUSERWORKNODeal({props,modelObj,model,args,componentKey}) {
  CurrentUtils._loadUser(false, (userJson) => {
    //如果是人员选择
    unref(modelObj)[unref(model).key] = userJson["userSn"];
  })
}

//函数用于获取指定人所在部门名称
export async function exactDEPTNAMEDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      const userJson: any = await getUserById(valueList[0]);
      unref(modelObj)[unref(model).key] = userJson["deptName"];
    }
  }
}

//获取日期里面的年份
export function exactYEARDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0] && valueList[0].$y) {
      return valueList[0].$y;
    }
  }
}

/**
 * 获取时间跟当前时间的年份差距
 * @param props
 * @param modelObj
 * @param args
 */
export function exactYEARCOUNTDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      if ((valueList[0].$d + "") !== 'Invalid Date') {
        return dayjs().diff(valueList[0], 'year');
      } else {
        return "";
      }
    }
  }
}

//获取日期里面的年份
export function exactYEARENDDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      if ((valueList[0].$d + "") !== 'Invalid Date') {
        return dayjs(valueList[0].endOf('year')).format(unref(props).format || "YYYY-MM-DD");
      } else {
        return "";
      }
    }
  }
}

//获取日期里面的年份
export function exactYEARBEGINDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      if ((valueList[0].$d + "") !== 'Invalid Date') {
        return dayjs(valueList[0].startOf('year')).format(unref(props).format || "YYYY-MM-DD");
      } else {
        return "";
      }
    }
  }
}

//将字符串 转换成日期对象
export function exactDATEDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      return valueList[0];
    }
  }
}

//函数可以将指定日期加/减指定天数
export function exactDATEDELTADeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0] && valueList[1]) {
      const dateObj: any = dayjs(valueList[0]).add(valueList[1], 'day')
      if ((dateObj.$d + "") !== 'Invalid Date') {
        return dayjs(dateObj).format(unref(props).format || "YYYY-MM-DD");
      } else {
        return "";
      }
    }
  }
}

//获取月份结束日期
export function exactMonthEndDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      if ((valueList[0].$d + "") !== 'Invalid Date') {
        return dayjs(valueList[0].endOf('month')).format(unref(props).format || "YYYY-MM-DD");
      } else {
        return "";
      }
    }
  }
}


//函数可以将指定日期加/减指定天数
export function exactWEEKNUMDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      if ((valueList[0].$d + "") !== 'Invalid Date') {
        return valueList[0].week();
      } else {
        return "";
      }
    }
  }
}


//获取日期的月份
export function exactMONTHDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    console.log(valueList, "--------------------valueList")
    if (valueList && valueList[0] && valueList[0].$M) {
      return valueList[0].$M + 1;
    } else {
      return "";
    }
  }
}

//获取日期的天数
export function exactDAYDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0] && valueList[0].$D) {
      return valueList[0].$D;
    } else {
      return "";
    }
  }
}

//获取俩个时间的时间间隔天数
export function exactDAYSDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0] && valueList[1]) {
      return dayjs(valueList[1]).diff(valueList[0], "day");
    } else {
      return "";
    }
  }
}

//获取俩个时间的时间间隔天数
export function exactDateRangeDaysDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0] && valueList[1]) {
      return dayjs(valueList[1]).diff(valueList[0], "day");
    } else {
      return "";
    }
  }
}


//获取日期的hour
export function exactHOURDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey}, "YYYY-MM-DD HH:mm");
    if (valueList && valueList[0] && valueList[0].$M) {
      return valueList[0].$H;
    } else {
      return "";
    }
  }
}

//获取日期的月份
export function exactMINUTEDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey}, "YYYY-MM-DD HH:mm");
    if (valueList && valueList[0] && valueList[0].$M) {
      return valueList[0].$m;
    } else {
      return "";
    }
  }
}

//获取日期的月份
export function exactSECONDDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getDateAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0] && valueList[0].$M) {
      return valueList[0].$M + 1;
    } else {
      return "";
    }
  }
}

/**
 * 函数比较两个值是否相等，相等则返回true，支持数字和日期组件
 * @param props
 * @param modelObj
 * @param args
 */
export function exactEqDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = true;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList[0] && valueList[1]) {
      if (valueList[0] === valueList[1]) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}

/**
 * 函数用于比较两个数的大小，value1大于等于value2返回true
 * @param props
 * @param modelObj
 * @param args
 */
export function exactGeDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      if (valueList[0] >= valueList[1]) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}

/**
 * 函数用于比较两个数的大小，value1大于value2返回true
 * @param props
 * @param modelObj
 * @param args
 */
export function exactGtDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      if (valueList[0] > valueList[1]) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}

/**
 * 函数用于比较两个数的大小，value1小于等于value2返回true
 * @param props
 * @param modelObj
 * @param args
 */
export function exactLeDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      if (valueList[0] <= valueList[1]) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}

/**
 * 函数用于比较两个数的大小，value1小于value2返回true
 * @param props
 * @param modelObj
 * @param args
 */
export function exactLtDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      if (valueList[0] < valueList[1]) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}

/**
 * 函数用于比较两个值是否相等，不相等则返回true
 * @param props
 * @param modelObj
 * @param args
 */
export function exactNeDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 2) {
      if (valueList[0] === valueList[1]) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}

/**
 * 函数返回与指定表达式相反的布尔值。
 * @param props
 * @param modelObj
 * @param args
 */
export function exactNotDeal({props,modelObj,model,args,componentKey}) {
  let backValue: boolean = false;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = !valueList[0];
    }
  }
  return backValue;
}

/**
 *
 * @param props
 * @param modelObj
 * @param args
 */
export function exactNumberCompareDeal({props,modelObj,model,args,componentKey}) {
  let backValue: boolean = false;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0] && valueList[1]) {
      if (valueList[1] > valueList[0]) {
        return true;
      } else {
        return false;
      }
    }
  }
  return backValue;
}


/**
 * 函数判断一个条件能否满足；如果满足返回一个值，如果不满足则返回另外一个值
 * @param props
 * @param modelObj
 * @param args
 */
export function exactIfDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length === 3) {
      if (GoingNewUtils.parseBoolean(valueList[0])) {
        return valueList[1];
      } else {
        return valueList[2];
      }
    }
  }
  return backValue;
}


/**
 * 函数可以将数字格式化为人民币格式
 * @param props
 * @param modelObj
 * @param args
 */
export function exactRmbFormatDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = null;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = cashToChinese(valueList[0]);
    }
  }
  return backValue;
}

/**
 * 函数可以获取文本1在文本2中的开始位置
 * @param props
 * @param modelObj
 * @param args
 */
export function exactSearchDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = null;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = (valueList[1] + "").indexOf(valueList[0])
    }
  }
  return backValue;
}

/**
 * 函数可以删除文本首尾的空格
 * @param props
 * @param modelObj
 * @param args
 */
export function exactTrimDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = (valueList[0] + "").trim();
    }
  }
  return backValue;
}

/**
 * 函数可以将一个文本中的所有小写字母转换为大写字母
 * @param props
 * @param modelObj
 * @param args
 */
export function exactUpperDeal({props,modelObj,model,args,componentKey}) {
  let backValue: any = "";
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList[0]) {
      backValue = (valueList[0] + "").toUpperCase();
    }
  }
  return backValue;
}

/**
 * 空函数定义
 * @param modelObj
 * @param args
 */
export function isEmptyFunDeal({props,modelObj,model,args,componentKey}) {
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    const elValue = valueList[0];
    if (valueList && elValue) {
      if (typeof (elValue) === "string") {
        if (elValue == null || elValue === "") {
          return true
        } else {
          return false
        }
      } else if (typeof (elValue) === "object") {
        if (Array.isArray(elValue)) {
          if (elValue.length === 0) {
            return true;
          } else {
            return false;
          }
        } else {
          if (JSON.stringify(elValue) == "{}") {
            return true;
          } else {
            return false
          }
        }
      }
    }
  }
}

/**
 * AVERAGE函数可以获取一组数值的算术平均值
 * @param props
 * @param modelObj
 * @param args
 */
export function averageFunDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getNumberAry({props,modelObj,model,args,componentKey});
    if (valueList && valueList.length > 0) {
      //计算总和
      backValue = (valueList.reduce((prev, cur) => {
        return prev + cur
      }, 0)) / valueList.length;
    }
  }
  return backValue;
}

/**
 * CONCATENATE函数可以将多个文本合并成一个文本
 * @param props
 * @param modelObj
 * @param args
 */
export function concateNameFunDeal({props,modelObj,model,args,componentKey}) {
  let backValue = 0;
  if (Array.isArray(args)) {
    const valueList: any = getTextAry({props,modelObj,model,args,componentKey});
    //将多个文本合并起来
    backValue = valueList.join('');
  }
  return backValue;
}
